import { Checkbox } from "@/components/ui/checkbox";

const CATEGORIES = {
  condominium_amenities: {
    label: "Condomínio",
    options: [
      "Academia", "Área verde", "Brinquedoteca", "Churrasqueira", "Elevador",
      "Lavanderia", "Piscina", "Playground", "Portaria 24h", "Quadra esportiva",
      "Salão de festas", "Salão de jogos", "Sauna",
    ],
  },
  unit_amenities: {
    label: "Comodidades",
    options: [
      "Apartamento cobertura", "Ar condicionado", "Banheira", "Box", "Churrasqueira",
      "Chuveiro a gás", "Closet", "Garden/Área privativa", "Novos ou reformados",
      "Piscina privativa", "Somente uma casa no terreno", "Tanque", "Televisão",
      "Utensílios de cozinha", "Ventilador de teto",
    ],
  },
  wellness_features: {
    label: "Bem-estar",
    options: [
      "Janelas grandes", "Rua silenciosa", "Sol da manhã", "Sol da tarde", "Vista livre",
    ],
  },
  furniture_features: {
    label: "Mobílias",
    options: [
      "Armários na cozinha", "Armários no quarto", "Armários nos banheiros",
      "Cama de casal", "Cama de solteiro", "Mesas e cadeiras de jantar", "Sofá",
    ],
  },
  accessibility_features: {
    label: "Acessibilidade",
    options: [
      "Banheiro adaptado", "Corrimão", "Piso tátil",
      "Quartos e corredores com portas amplas", "Rampas de acesso", "Vaga de garagem acessível",
    ],
  },
  appliance_features: {
    label: "Eletrodomésticos",
    options: [
      "Fogão", "Fogão cooktop", "Geladeira", "Máquina de lavar", "Microondas",
    ],
  },
  room_features: {
    label: "Cômodos",
    options: [
      "Área de serviço", "Cozinha americana", "Home-office", "Jardim", "Quintal", "Varanda",
    ],
  },
} as const;

export type AmenityCategory = keyof typeof CATEGORIES;

interface AmenitiesSelectorProps {
  values: Record<AmenityCategory, string[]>;
  onChange: (category: AmenityCategory, selected: string[]) => void;
}

const AmenitiesSelector = ({ values, onChange }: AmenitiesSelectorProps) => {
  const toggle = (category: AmenityCategory, item: string) => {
    const current = values[category] || [];
    const updated = current.includes(item)
      ? current.filter((v) => v !== item)
      : [...current, item];
    onChange(category, updated);
  };

  return (
    <div className="space-y-4">
      {(Object.keys(CATEGORIES) as AmenityCategory[]).map((cat) => {
        const { label, options } = CATEGORIES[cat];
        return (
          <div key={cat} className="border border-border rounded-lg p-3">
            <h4 className="font-body text-sm font-semibold text-foreground mb-2">{label}</h4>
            <div className="grid grid-cols-2 gap-1.5">
              {options.map((opt) => (
                <label key={opt} className="flex items-center gap-2 text-xs font-body text-muted-foreground cursor-pointer hover:text-foreground">
                  <Checkbox
                    checked={(values[cat] || []).includes(opt)}
                    onCheckedChange={() => toggle(cat, opt)}
                  />
                  {opt}
                </label>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export { CATEGORIES };
export default AmenitiesSelector;
